import { Popover as BasePopover } from "@base-ui/react/popover";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { MonthPickerPortalProps } from "./MonthPicker.types";

export function MonthPickerPortal({
  children,
  ...props
}: MonthPickerPortalProps) {
  const container = useFloatingPortalContainer();

  return (
    <BasePopover.Portal
      data-slot="month-picker-portal"
      container={container}
      {...props}
    >
      {children}
    </BasePopover.Portal>
  );
}
